<script setup lang="ts">
const items = [
  {
    title: 'Turunkan Angka Retur',
    description:
      'Deteksi cepat dan follow-up langsung menekan potensi retur berulang.',
    icon: 'hugeicons:delivery-return-01'
  },
  {
    title: 'Optimalkan Kinerja Operasional',
    description:
      'CS dan tim operasional bekerja lebih efisien dengan data real-time.',
    icon: 'material-symbols:speed-outline'
  },
  {
    title: 'Jaga Rating & Review Toko',
    description:
      'Pelanggan tetap percaya karena kamu proaktif menyelesaikan masalah.',
    icon: 'material-symbols:star-half'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Dari Komplain Jadi Kepercayaan"
    description="Setiap pengiriman bermasalah bukan lagi ancaman, tapi peluang untuk memperkuat pengalaman pelanggan."
    hero-image="/images/undelivery-banner-3.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
